export class ICategory {
    id;
    parentId;
    title;
    children;
}
